import { create } from './Create/Create.i18n.en'
import { importFromCsv } from './Import/Import.i18n.en'
import { update } from './Update/Update.i18n.en'

export const machines = {
  create,
  update,
  importFromCsv,
}
